import { useQuery, useMutation } from 'convex/react';
import { api } from '@convex/_generated/api';
import { useAppStore } from '@/lib/store';
import { isConvexEnabled } from '@/lib/convex';

export function useBrainDoc() {
  const { userId } = useAppStore();
  const result = useQuery(
    api.brainDocs.get,
    isConvexEnabled && userId ? { userId } : 'skip'
  );
  const upsertBrainDoc = useMutation(api.brainDocs.upsert);

  // Return full object so callers can access .content and .updatedAt
  return {
    brainDoc: result ?? null,           // { content, updatedAt, ... } or null
    brainDocContent: result?.content ?? null,  // string for buildSystemPrompt
    upsertBrainDoc,
  };
}
